@if(showToastFailure){
<div class="toast flex justify-between alert-danger">
    <p class="toast__text">{{toastMsg}}</p>
    <img src="assets/images/icons/white-close-icon.svg" alt="images" width="22" height="22" (click)="handler__close()"
        class="cursor-pointer">
</div>
}